// @flow
import React from "react";
import { token } from "./CsrfToken";
import qs from "qs";
require("es6-promise").polyfill();
require("isomorphic-fetch");

const fetchHtml = (url: string, parameters: Object = {}): Promise<any> => {
  var fullUrl = url;
  if (parameters) {
    fullUrl += "?" + qs.stringify(parameters, { arrayFormat: "brackets" });
  }
  return fetch(fullUrl, {
    credentials: "include",
    headers: {
      "Content-Type": "text/html",
      Accepts: "text/html",
      "X-CSRF-Token": token(),
    },
  }).then((response) => response.text());
};

const basicFetch = (url: string, parameters: Object = {}): Promise<any> => {
  var fullUrl = url;
  if (parameters) {
    fullUrl += "?" + qs.stringify(parameters, { arrayFormat: "brackets" });
  }
  return fetch(fullUrl, {
    credentials: "include",
    headers: {
      "Content-Type": "text/html",
      Accepts: "text/html",
      "X-CSRF-Token": token(),
    },
  });
};

const fetchJsonNoParse = (url: string, parameters: Object = {}): Promise<any> => {
  var fullUrl = url;
  if (parameters) {
    fullUrl += "?" + qs.stringify(parameters, { arrayFormat: "brackets" });
  }
  return fetch(fullUrl, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accepts: "application/json",
      "X-CSRF-Token": token(),
    },
  });
};

const fetchJson = (url: string, parameters: Object = {}): Promise<any> => {
  var fullUrl = url;
  if (parameters) {
    fullUrl += "?" + qs.stringify(parameters, { arrayFormat: "brackets" });
  }
  return fetch(fullUrl, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accepts: "application/json",
      "X-CSRF-Token": token(),
    },
  }).then((response) => response.json());
};

function handleErrors(response) {
  if (!response.ok) {
    if (response.status == 401) {
      alert("You are not authorised to perform this action.");
      return;
    }
    return response.json().then((json) => {
      console.log("json error!", json);
      throw new Error(json.errors);
    });
  }
  return response.json();
}

const post = (url: string, parameters: Object = {}, method: string = "POST") => {
  return fetch(url, {
    body: JSON.stringify(parameters),
    method: method,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accepts: "application/json",
      "X-CSRF-Token": token(),
    },
  }).then(handleErrors);
};

const postMultipart = (url: string, parameters: Object = {}) => {
  // Create a new FormData object
  const formData = new FormData();

  // Loop through parameters and append them to formData
  Object.keys(parameters).forEach((key) => {
    formData.append(key, parameters[key]);
  });

  return fetch(url, {
    body: formData, // Use formData as the body
    method: "POST",
    credentials: "include",
    headers: {
      // You should not set "Content-Type" explicitly for multipart/form-data, as the browser will automatically handle the correct boundary.
      Accept: "application/json",
      "X-CSRF-Token": token(),
    },
  }).then(handleErrors);
};

function normalPost(url: string, params: {}, newTab = false, method = "POST") {
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", url);
  if (newTab) {
    form.setAttribute("target", "_blank");
  }

  // Add required rails authenticity token
  var tokenField = document.createElement("input");
  tokenField.setAttribute("type", "hidden");
  tokenField.setAttribute("name", "authenticity_token");
  tokenField.setAttribute("value", token());
  form.appendChild(tokenField);

  const keyValues = qs
    .stringify(params, { arrayFormat: "brackets", encode: false })
    .split("&")
    .map((field) => field.split("="));

  keyValues.forEach((field) => {
    var key = field[0];
    var value = field[1];
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", value);
    form.appendChild(hiddenField);
  });
  document.body.appendChild(form);
  form.submit();
}

// experimental
// const useFetchJson = (url, parameters) => {
//   const [response, setResponse] = React.useState(null);
//   const [error, setError] = React.useState(null);
//   const [isLoading, setIsLoading] = React.useState(false);
//   React.useEffect(() => {
//     const fetchData = async () => {
//       setIsLoading(true);
//       fetchJson(url, parameters)
//         .then(json => {
//           if (json.errors) {
//             setError(json.errors);
//           } else {
//             setResponse(json);
//             setIsLoading(false);
//           }
//         })
//         .catch(error => {
//           setError(error);
//         });
//     };
//     fetchData();
//   }, []);
//   return { response, error, isLoading };
// };

export { fetchJson, fetchJsonNoParse, fetchHtml, post, normalPost, postMultipart, basicFetch };
